export const fisherYatesShuffle = (arr) => {
    let new_arr = [...arr];
    const len = new_arr.length;
    for (let i = len - 1; i >= 0; i--) {
        const rand = Math.floor(Math.random() * i );
        [new_arr[i], new_arr[rand]] = [new_arr[rand], new_arr[i]];
        // a[]
    }
    return new_arr;
}